import { Call as CallIcon } from '@mui/icons-material';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { FC } from 'react';
import { AgentDirectoryEntry } from '../../../../interfaces/calls';

export interface TransferStatusModalProps {
  open: boolean;
  agent: Pick<AgentDirectoryEntry, 'name'>;
  onHangup: () => void;
  isError?: boolean;
  errorMessage?: string;
  onClose?: () => void;
}

export const TransferStatusModal: FC<TransferStatusModalProps> = ({
  open,
  agent,
  onHangup,
  isError = false,
  errorMessage,
  onClose,
}) => {
  if (!open) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '8px',
        padding: '24px',
        background: '#fff',
        maxWidth: 300,
        width: '70%',
        boxShadow: 3,
        zIndex: 10,
      }}>
      <Box sx={{ py: 2, textAlign: 'center' }}>
        {isError ? (
          <>
            <Typography variant='body1' sx={{ mb: 1, color: 'error.main' }}>
              Transfer to <strong>{agent.name}</strong> failed
            </Typography>
            {errorMessage && (
              <Typography variant='body2' color='text.secondary'>
                {errorMessage}
              </Typography>
            )}
          </>
        ) : (
          <>
            <Typography variant='body1' sx={{ mb: 1 }}>
              <strong>Connecting with...</strong>
            </Typography>

            <Typography variant='body1' sx={{ mt: 2 }}>
              {agent.name}
            </Typography>
          </>
        )}
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, pt: 1 }}>
        {isError && onClose && (
          <Button
            variant='outlined'
            onClick={onClose}
            sx={{
              textTransform: 'none',
              borderRadius: '20px',
              px: 4,
            }}>
            Close
          </Button>
        )}
        <IconButton
          onClick={onHangup}
          sx={{
            bgcolor: 'error.main',
            color: 'white',
            '&:hover': {
              bgcolor: 'error.dark',
            },
          }}>
          <CallIcon sx={{ transform: 'rotate(135deg)' }} />
        </IconButton>
      </Box>
    </Box>
  );
};
